import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// ACCUMULATOR_ISSUE_UPDATE_ATTACHMENT

const mutation = gql`
  mutation accumulatorIssueUpdateAttachment(
    $id: ID!
    $attachment: AccumulatorIssueUpdateAttachmentInput!
  ) {
    accumulatorIssueUpdateAttachment(id: $id, attachment: $attachment) {
      id
      form_attachment {
        id
        title
        notes
      }
    }
  }
`
export default function useAccumulatorIssueUpdateAttachment() {
  const { onMutate: onAccumulatorIssueAttachmentUpdate, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'accumulatorIssueUpdateAttachment',
      successMessage: 'Attachment updated'
    })

  return { onAccumulatorIssueAttachmentUpdate, loading }
}
